(() => {
  const init = (root) => {
    if (!root || root.dataset.helpReady === 'true') return;
    root.dataset.helpReady = 'true';

    const form = root.querySelector('[data-help-search-form]');
    const input = root.querySelector('[data-help-search]');
    const results = root.querySelector('[data-help-results]');
    const endpoint = root.dataset.predictiveUrl;
    const blogPath = root.dataset.blogPath;
    let requestController;
    let timer;

    const closeResults = () => {
      results.hidden = true;
      results.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
    };

    const renderMessage = (message, loading = false) => {
      results.innerHTML = '';
      const element = document.createElement(loading ? 'span' : 'p');
      element.textContent = message;
      results.appendChild(element);
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    };

    const renderArticles = (articles) => {
      results.innerHTML = '';

      if (!articles.length) {
        renderMessage('No matching Help Center article. Try fewer words or contact support.');
        return;
      }

      articles.forEach((article) => {
        const link = document.createElement('a');
        const heading = document.createElement('strong');
        const meta = document.createElement('small');
        link.href = article.url;
        heading.textContent = article.title;
        meta.textContent = 'Help guide';
        link.append(heading, meta);
        results.appendChild(link);
      });

      const allResults = document.createElement('a');
      allResults.href = `${form.action}?type=article&options%5Bprefix%5D=last&q=${encodeURIComponent(input.value.trim())}`;
      allResults.className = 'sky-center-search__all';
      allResults.textContent = 'View all article results →';
      results.appendChild(allResults);
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    };

    const search = async () => {
      const query = input.value.trim();
      if (query.length < 2 || !endpoint) {
        closeResults();
        return;
      }

      requestController?.abort();
      requestController = new AbortController();
      renderMessage('Searching Help Center…', true);

      try {
        const url = new URL(endpoint, window.location.origin);
        if (!url.pathname.endsWith('.json')) url.pathname = `${url.pathname}.json`;
        url.searchParams.set('q', query);
        url.searchParams.set('resources[type]', 'article');
        url.searchParams.set('resources[limit]', '10');
        url.searchParams.set('resources[options][fields]', 'title,body,tag');

        const response = await fetch(url, { headers: { Accept: 'application/json' }, signal: requestController.signal });
        if (!response.ok) throw new Error(`Search failed: ${response.status}`);
        const data = await response.json();
        let articles = data?.resources?.results?.articles || [];

        if (blogPath) {
          articles = articles.filter((article) => {
            try {
              return new URL(article.url, window.location.origin).pathname.startsWith(blogPath);
            } catch (_) {
              return false;
            }
          });
        }
        renderArticles(articles);
      } catch (error) {
        if (error.name !== 'AbortError') renderMessage('Search is temporarily unavailable. Press Search to view article results.');
      }
    };

    input?.addEventListener('input', () => {
      window.clearTimeout(timer);
      timer = window.setTimeout(search, 180);
    });

    input?.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeResults();
    });

    root.querySelectorAll('[data-help-suggestion]').forEach((button) => {
      button.addEventListener('click', () => {
        input.value = button.dataset.helpSuggestion || '';
        input.focus();
        search();
      });
    });

    document.addEventListener('click', (event) => {
      if (!form.contains(event.target)) closeResults();
    });
  };

  document.querySelectorAll('[data-help-center]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-help-center]')));
})();
